import React, { useState } from 'react';
import './Reviewpopup.css';

const Reviewpopup = ({ onClose, onSubmit, eventId, eventTitle, eventDate, eventLocation }) => {
  const [description, setDescription] = useState('');
  const [rating, setRating] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const formatEventDate = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short'
    });
  };

  const handleSubmit = async () => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const resolvedEventId = eventId;
    const token = localStorage.getItem('token');

    if (!resolvedEventId) {
      setSubmitError('Event not found. Please close and try again.');
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');
    try {
      const response = await fetch(`${API_BASE_URL}/api/v1/review/${resolvedEventId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({
          title: 'Review',
          description,
          rating: rating || 1
        })
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to submit review');
      }

      if (onSubmit) {
        onSubmit(data.review);
      }
      onClose();
    } catch (error) {
      console.error('Failed to submit review', error);
      setSubmitError(error.message || 'Unable to submit review.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="review-overlay">
      <div className="review-container">
        {/* Close Button */}
        <button className="close-btn" onClick={onClose}>
          X
        </button>

        <h1 className="review-title">Leave a Review</h1>
        <p className="review-subtitle">
          {eventTitle ? `How was your experience at ${eventTitle}?` : 'How was your experience?'}
        </p>

        {/* Event Logo Section */}
        <div className="event-info">
          <h2 className="event-name">{eventTitle || 'Event'}</h2>
          <p className="event-details">
            {[formatEventDate(eventDate), eventLocation].filter(Boolean).join(' | ')}
          </p>
        </div>

        {/* Star Rating Section */}
        <div className="star-rating">
          {[1, 2, 3, 4, 5].map((value) => (
            <button
              key={value}
              type="button"
              className={`star ${value <= rating ? 'filled' : ''}`}
              onClick={() => setRating(value)}
              aria-label={`Rate ${value} star${value > 1 ? 's' : ''}`}
            >
              ★
            </button>
          ))}
        </div>

        {/* Feedback Textarea */}
        <textarea
          className="feedback-input"
          placeholder="Your feedback helps us design better events and improve future experiences."
          value={description}
          onChange={(event) => setDescription(event.target.value)}
        ></textarea>

        {/* Submit Button */}
        {submitError && <div className="review-error">{submitError}</div>}
        <button className="submit-btn" onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </div>
  );
};

export default Reviewpopup;

